import { debounce } from '@fe/core';
import { Button } from '@progress/kendo-react-buttons';
import { Slider } from '@progress/kendo-react-inputs';
import { useMemo, useState } from 'react';
import { AlertSoundTypeOptions } from '../../../../../components/weather/settings/settings-options';
import { PlayCircleOutline } from '../../../../../icons/icons';
import { playTestSound } from '../../../../../monitoring/alerts/sound/play-sound';
import { DropdownListWithValueField } from '../../../../components/inputs/DropdownListWithValueField';
import MarkerText from '../../../../components/inputs/MarkerText';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store-hooks';
import { setSetting } from '../../../../state/slices/settings-slice';
import { useSettingDropdownValue } from '../../../home/hooks/settings';
import { useSearchContext } from '../../context/SettingsSearchContext';

export function SettingsAlertSoundElement() {
    const dispatch = useAppDispatch();
    const type = useSettingDropdownValue(AlertSoundTypeOptions, 'alertSoundType');
    const volumeDefault = useAppSelector((x) => x.settings.alertSoundVolume);
    const [volume, setVolume] = useState(volumeDefault);
    const context = useSearchContext();
    const debounceSettingsChange = useMemo(
        () =>
            debounce((value: number) => {
                dispatch(setSetting('alertSoundVolume', value));
            }, 1000),
        [dispatch]
    );

    const soundTest = () => {
        playTestSound({ type: type.value, volume });
    };

    return (
        <>
            <div className="d-flex align-items-center gap-2 px-3">
                <div className="flex-grow-1"><MarkerText highlight={context.term}>Sound type</MarkerText></div>

                <Button svgIcon={PlayCircleOutline} fillMode={'outline'} themeColor={'success'} onClick={soundTest}></Button>
                <div style={{ width: 300 }}>
                    <DropdownListWithValueField {...type} />
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-between px-3">
                <div><MarkerText highlight={context.term}>{`Volume ${volume}%`}</MarkerText></div>
                <Slider
                    min={0}
                    max={100}
                    step={1}
                    value={volume}
                    onChange={(e) => {
                        setVolume(Math.floor(e.value));
                        debounceSettingsChange(e.value);
                    }}
                />
            </div>
        </>
    );
}
